import { lazy, memo, Suspense } from 'react';

const ComponentLoad = lazy(() => import('./component'));

const ReturnProductForm = props => (
  <Suspense fallback={null}>
    <ComponentLoad {...props} />
  </Suspense>
);

export default memo(ReturnProductForm);
